import {
  DASH_KNEE_BASE_FRAC,
  DASH_KNEE_BEND,
  DASH_LEAN_RAD,
  DASH_STRIDE_AMP_BOOST,
  DASH_THIGH_LIFT,
  STRIDE_ARM_CROSS,
  STRIDE_ARM_PITCH_AMP,
  STRIDE_BOB_AMPLITUDE,
  STRIDE_CYCLE_DISTANCE_RATIO,
  STRIDE_FOOT_ROLL,
  STRIDE_LEG_PITCH_AMP,
  STRIDE_LOWER_ARM_BEND,
} from './avatarPoseConstants'

/**
 * 走行モーションのライブ調整パラメータ。
 *
 * animateVrmAvatar が毎フレーム参照する単一のミュータブルオブジェクト。
 * dev 限定の調整パネル（runMotionTuner）が値を書き換えると、その場で
 * 走りの見た目へ反映される。各既定値は avatarPoseConstants の出荷値に一致し、
 * パネルを操作しない限り挙動は現状と完全に同一になる。
 */
export interface RunMotionParams {
  /** 走行時の前傾角（rad）。 */
  leanRad: number
  /** 上下バウンス振幅倍率。 */
  bobAmplitude: number
  /** 上腕の前後振り振幅（rad）。 */
  armPitchAmp: number
  /** 腕の斜め前（内側）クロス量（rad）。 */
  armCross: number
  /** 肘の基準曲げ角（rad）。 */
  lowerArmBend: number
  /** 上脚の前後振り振幅（rad）。 */
  legPitchAmp: number
  /** 腿の追加持ち上げ（rad）。 */
  thighLift: number
  /** 膝（下脚）曲げ量（rad）。 */
  kneeBend: number
  /** 後脚に残す膝曲げ最低割合（0..1）。 */
  kneeBaseFrac: number
  /** 足首ロール（かかと→つま先）振幅（rad）。 */
  footRoll: number
  /** 1 サイクルで進む距離 / 身長比（ケイデンス）。 */
  cycleDistanceRatio: number
  /** 走行スイング/バウンス増幅率。 */
  dashStrideAmpBoost: number
}

export const runMotionParams: RunMotionParams = {
  leanRad: DASH_LEAN_RAD,
  bobAmplitude: STRIDE_BOB_AMPLITUDE,
  armPitchAmp: STRIDE_ARM_PITCH_AMP,
  armCross: STRIDE_ARM_CROSS,
  lowerArmBend: STRIDE_LOWER_ARM_BEND,
  legPitchAmp: STRIDE_LEG_PITCH_AMP,
  thighLift: DASH_THIGH_LIFT,
  kneeBend: DASH_KNEE_BEND,
  kneeBaseFrac: DASH_KNEE_BASE_FRAC,
  footRoll: STRIDE_FOOT_ROLL,
  cycleDistanceRatio: STRIDE_CYCLE_DISTANCE_RATIO,
  dashStrideAmpBoost: DASH_STRIDE_AMP_BOOST,
}
